"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Arrow = function Arrow() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react.default.createElement("path", {
    d: "M47.25 15l-2.09-2.09L25 33.08 4.84 12.9 2.75 15 25 37.25z"
  }));
};

var _default = Arrow;
exports.default = _default;